<template lang='pug'>
  spreadsheet(:opts='opts')
</template>

<script>
// Generated by CoffeeScript 2.3.0
var m;

export default m = {
  data: function() {
    return {
      opts: {
        tableName: 'faq',
        displayName: 'FAQ',
        columns: [
          {
            label: "问题",
            type: 'textarea'
          },
          {
            label: "选项A"
          },
          {
            label: "选项B"
          },
          {
            label: "选项C"
          },
          {
            label: "选项D"
          },
          {
            label: "答案",
            width: 40
          },
          {
            label: "关键字"
          },
          {
            label: "解释"
          }
        ],
        defaultItem: {
          permissions: {
            '所有人': '读取'
          }
        },
        maxItem: 1000,
        showPagination: true,
        expandable: true,
        creatable: true,
        trackable: true
      }
    };
  }
};
</script>




